import React from "react";
import Sugar from "sugar";

import { withRouter } from 'react-router-dom';

import "./assets/scss/App.scss";

import PymFrame from './core/PymFrame';
import Widget from './Widget';

const archie = require("./assets/data/archie.json");
Sugar.extend()

function Widgets({ match }) {
  const { widget } = match.params;
  const collection = archie.collections.find( x => x.Slug === widget );

  return (
    <PymFrame>
      <Widget collection={ collection }/>
    </PymFrame>
  )
}

export default withRouter( Widgets );
